  import React from 'react';
  import ReactDOM from 'react-dom/client';
  import "bootstrap/dist/css/bootstrap.min.css";
  import "bootstrap/dist/js/bootstrap.bundle.min.js";
  import './style.css';
  import './responsive.css';
  import App from './App';
  import reportWebVitals from './reportWebVitals';
import { ToastProvider } from './components/ToastProvider';

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <ToastProvider>  
      <App />
      </ToastProvider>
    </React.StrictMode>
  );

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
